import { render, staticRenderFns } from "./RiskAssessmentClosedNetworkForm.vue?vue&type=template&id=357438bf"
import script from "./RiskAssessmentClosedNetworkForm.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentClosedNetworkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports